export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "model": {
          "harvested_package": {
            "number": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Total procesado"])},
            "discarded_number": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Descarte"])},
            "crop_har_package": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Empaque"])}
          }
        }
      },
      "en": {
        "model": {
          "harvested_package": {
            "number": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Number"])},
            "discarded_number": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Discarded"])},
            "crop_har_package": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Harvest package"])}
          }
        }
      }
    }
  })
}